<div class="relative inline-block text-left group py-2">

	<button
		class="cursor-pointer flex items-center"
		(click)="handleClick()"
	>
		@if (picture) {
			<img
				[src]="picture"
				[alt]="text"
				class="size-10 rounded-full object-cover border-2 border-peps-dark-200 group-hover:border-peps-gold transition-colors duration-300"
			/>
		} @else {
			<div class="size-10 rounded-full bg-peps-dark-200 flex items-center justify-center border-2 border-transparent group-hover:border-peps-gold transition-colors duration-300">
				<span class="text-peps-dark-700 font-bold text-sm uppercase">{{ text }}</span>
			</div>
		}
	</button>

	@if (isMobile && isOpen) {
		<div class="z-20 bg-peps-dark-700 transition duration-200 w-max min-w-full absolute right-0 border border-peps-dark-600 mt-2">
			<ul>
				@for (item of items; track item.label) {
					@if (item.isSeparator) {
						<li class="border-t border-peps-dark-600 my-1"></li>
					}
					<li>
						<button
							(click)="select(item.action)"
							class="flex items-center gap-2 px-4 py-3 w-full text-left cursor-pointer whitespace-nowrap transition-colors duration-300 uppercase"
							[ngClass]="item.isActive ? 'text-peps-gold' : 'hover:bg-peps-dark-500'"
						>
							@if (item.image) {
								<img [src]="item.image" [alt]="item.label" class="w-5 h-5">
							}
							{{ item.label }}
						</button>
					</li>
				}
			</ul>
		</div>
	}

	<div
		class="absolute z-20 bg-peps-dark-700 invisible opacity-0 group-hover:opacity-100 group-hover:visible transition duration-200 w-max min-w-full hidden lg:block border border-peps-dark-600 mt-2 right-0"
	>
		<ul>
			@for (item of items; track item.label) {
				@if (item.isSeparator) {
					<li class="border-t border-peps-dark-600 my-1"></li>
				}
				<li>
					<button
						(click)="select(item.action)"
						class="flex items-center gap-2 px-4 py-3 w-full text-left cursor-pointer whitespace-nowrap transition-colors duration-300 uppercase"
						[ngClass]="item.isActive ? 'text-peps-gold' : 'hover:bg-peps-dark-500'"
					>
						@if (item.image) {
							<img [src]="item.image" [alt]="item.label" class="w-5 h-5">
						}
						{{ item.label }}
					</button>
				</li>
			}
		</ul>
	</div>

</div>
